export const ProjectsListGetters = {
  Projects: 'ProjectsListGetters.Projects',
  ProjectsCount: 'ProjectsListGetters.ProjectsCount',
  ProjectsIsLoading: 'ProjectsListGetters.ProjectsIsLoading',
  ProjectsOffset: 'ProjectsListGetters.ProjectsOffset',
  ProjectsPaginationParams: 'ProjectsListGetters.ProjectsPaginationParams',
  ProjectsPerPage: 'ProjectsListGetters.ProjectsPerPage',
  ProjectsSortBy: 'ProjectsListGetters.ProjectsSortBy',
  ProjectsSortDirection: 'ProjectsListGetters.ProjectsSortDirection',
  ProjectsSortOrder: 'ProjectsListGetters.ProjectsSortOrder'
};

export const ProjectsListActions = {
  FilterListBySearchKey: 'ProjectsListActions.FilterListBySearchKey',
  GetProjects: 'ProjectsListActions.GetProjects',
  GetProjectsFilteredRecordCount: 'ProjectsListActions.GetProjectsFilteredRecordCount',
  SetProjectsFilters: 'ProjectsListActions.SetProjectsFilters',
  SetProjectsPaginationParameters: 'ProjectsListActions.SetProjectsPaginationParameters',
  SetProjectsSortOrder: 'ProjectsListActions.SetProjectsSortOrder'
};

export const ProjectsListMutations = {
  ResetProjectsPaginationOffset: 'ProjectsListMutations.ResetProjectsPaginationOffset',
  SetProjectsFilteredRecordCount: 'ProjectsListMutations.SetProjectsFilteredRecordCount',
  SetProjectsFilters: 'ProjectsListMutations.SetProjectsFilters',
  SetProjectsIsLoading: 'ProjectsListMutations.SetProjectsIsLoading',
  SetProjectsList: 'ProjectsListMutations.SetProjectsList',
  SetProjectsPaginationParameters: 'ProjectsListMutations.SetProjectsPaginationParameters',
  SetProjectsSearchParam: 'ProjectsListMutations.SetProjectsSearchParam',
  SetProjectsSortOrder: 'ProjectsListMutations.SetProjectsSortOrder'
};
